import { BTN, Stack, colors as zetColors } from '@zet/design-system'
import CreditCardFilled from '@zet/design-system/svg/CreditCardFilled'
import CreditCardOutlined from '@zet/design-system/svg/CreditCardOutlined'
import MoneyBagFilled from '@zet/design-system/svg/MoneyBagFilled'
import MoneyBagOutlined from '@zet/design-system/svg/MoneyBagOutlined'
import MoreFilled from '@zet/design-system/svg/MoreFilled'
import MoreOutlined from '@zet/design-system/svg/MoreOutlined'
import WiredEarPhones from '@zet/feature-loyalty/assets/svg/wiredEarphones.svg'
import { i18n } from '@zet/localization'
import BlueGiftBox from '@zet/svg/blueGiftBox'
import DeliveryBox from '@zet/svg/deliveryBox'
import DigitalSilver from '@zet/svg/digitalSilver'
import Earphones from '@zet/svg/earphones'
import Money from '@zet/svg/money'
import ShoppingBag from '@zet/svg/shoppingBag'
import SmartWatch from '@zet/svg/smartWatch'

import OnboardingGift from '../assets/svg/onBoardingGift.svg'

export const tierLevels = {
  Beginner: {
    tierCardHeading: 'tierBenefits.beginnerTierCardHeading',
  },
  Pro: {
    benefits: [
      {
        type: 'HIGHER_PAYOUT',
        cardTitle: i18n.t('loyaltyCardBenefits.5%HigherPayout'),
        title: i18n.t('tierBenefits.pro.5percentHigherPayout'),
        subTitle: i18n.t('tierBenefits.5percentHigherPayoutDetail'),
      },
      {
        type: 'AUGMONT_SILVER',
        cardTitle: i18n.t('loyaltyCardBenefits.digitalSilver'),
        title: i18n.t('tierBenefits.pro.5gmSilver'),
        subTitle: i18n.t('tierBenefits.5gmSilverDetail'),
      },
      {
        type: 'WELCOME_BONUS',
        title: i18n.t('tierBenefits.pro.zetCoinsWelcomeBonus'),
        subTitle: i18n.t('tierBenefits.50ZetCoinsAdded'),
      },
      {
        type: 'EXTRA_COINS',
        cardTitle: i18n.t('loyaltyCardBenefits.moreZETCoins'),
        title: i18n.t('tierBenefits.pro.zetCoinsOnSale'),
        subTitle: i18n.t('tierBenefits.earnUpto750Coins'),
      },
      {
        type: 'WIRED_EARPHONES',
        cardTitle: i18n.t('loyaltyCardBenefits.moreZETCoins'),
        title: i18n.t('tierBenefits.earphones'),
        subTitle: i18n.t('tierBenefits.earnUpto750Coins'),
      },
    ],
    oneTimeBenefits: [
      {
        type: 'AUGMONT_SILVER',
        cardTitle: i18n.t('loyaltyCardBenefits.digitalSilver'),
        title: i18n.t('tierBenefits.5gmSilver'),
        subTitle: i18n.t('tierBenefits.5gmSilverDetail'),
      },
      {
        type: 'WELCOME_BONUS',
        cardTitle: i18n.t('loyaltyCardBenefits.100WelcomeCoins'),
        title: i18n.t('tierBenefits.welcomeBonus'),
        subTitle: i18n.t('tierBenefits.100CoinsWelcome'),
      },
    ],
  },
  Expert: {
    heading: i18n.t('tierBenefits.expertHeading'),
    tierCardHeading: 'tierBenefits.expertTierCardHeading',
    zetCoins: 250,

    oneTimeBenefitsList: [
      'WELCOME_BONUS',
      'EAR_PHONES',
      'ONBOARDING_KIT',
      'ONBOARDING_GIFT',
    ],
    levelUpBenefits: [
      {
        title: i18n.t('loyaltyCardBenefits.10%HigherPayout'),
        type: 'HIGHER_PAYOUT',
      },
      {
        title: i18n.t('loyaltyCardBenefits.premiumEarphones'),
        type: 'EAR_PHONES',
      },
      {
        title: i18n.t('loyaltyCardBenefits.onboardingKit'),
        type: 'ONBOARDING_KIT',
      },
      {
        title: i18n.t('loyaltyCardBenefits.expertMoreZetCoins'),
        type: 'EXTRA_COINS',
      },
      {
        title: i18n.t('loyaltyCardBenefits.250WelcomePoints'),
        type: 'WELCOME_BONUS',
      },
    ],
    benefits: [
      {
        type: 'HIGHER_PAYOUT',
        cardTitle: i18n.t('loyaltyCardBenefits.5%HigherPayout'),
        title: i18n.t('tierBenefits.expert.10percentHigherPayout'),
        subTitle: i18n.t('tierBenefits.5percentHigherPayoutDetail'),
      },
      {
        type: 'EAR_PHONES',
        title: i18n.t('tierBenefits.premiumEarphones'),
        cardTitle: i18n.t('loyaltyCardBenefits.earphones'),
        subTitle: i18n.t('tierBenefits.earphonesDetail'),
      },
      {
        cardTitle: i18n.t('loyaltyCardBenefits.onboardingKit'),
        title: i18n.t('tierBenefits.expert.onboardingKit'),
        type: 'ONBOARDING_KIT',
        subTitle: i18n.t('tierBenefits.onboardingKitDetail'),
      },
      {
        type: 'ONBOARDING_GIFT',
        cardTitle: i18n.t('loyaltyCardBenefits.onboardingKit'),
        title: i18n.t('tierBenefits.genius.onboardingKit'),
        subTitle: i18n.t('tierBenefits.onboardingKitDetail'),
      },
      {
        type: 'EXTRA_COINS',
        cardTitle: i18n.t('loyaltyCardBenefits.moreZETCoins'),
        title: i18n.t('tierBenefits.expert.zetCoinsOnSale'),
        subTitle: i18n.t('tierBenefits.earn1000Points'),
      },
      {
        type: 'WELCOME_BONUS',
        cardTitle: i18n.t('loyaltyCardBenefits.250WelcomePoints'),
        title: i18n.t('tierBenefits.expert.zetCoinsWelcomeBonus'),
        subTitle: i18n.t('tierBenefits.250ZetCoins'),
      },
    ],
    oneTimeBenefits: [
      {
        type: 'EAR_PHONES',
        title: i18n.t('tierBenefits.earphones'),
        cardTitle: i18n.t('loyaltyCardBenefits.expert.earphones'),
        subTitle: i18n.t('tierBenefits.earphonesDetail'),
      },
      {
        cardTitle: i18n.t('loyaltyCardBenefits.onboardingKit'),
        title: i18n.t('tierBenefits.onboardingKit'),
        type: 'ONBOARDING_KIT',
        subTitle: i18n.t('tierBenefits.onboardingKitDetail'),
      },
      {
        type: 'WELCOME_BONUS',
        cardTitle: i18n.t('loyaltyCardBenefits.250WelcomePoints'),
        title: i18n.t('tierBenefits.expert.zetCoinsWelcomeBonus'),
        subTitle: i18n.t('tierBenefits.250ZetCoins'),
      },
    ],
  },
  Genius: {
    heading: i18n.t('tierBenefits.geniusHeading'),
    tierCardHeading: 'tierBenefits.geniusTierCardHeading',

    zetCoins: 500,
    oneTimeBenefitsList: [
      'WELCOME_BONUS',
      'SMART_WATCH',
      'ONBOARDING_KIT',
      'ONBOARDING_GIFT',
    ],
    levelUpBenefits: [
      {
        //icon: require('../assets/images/tierBenefits/higherPayout.png'),
        title: i18n.t('loyaltyCardBenefits.15%HigherPayout'),
        type: 'HIGHER_PAYOUT',
      },
      {
        //icon: require('../assets/images/tierBenefits/watch.png'),
        title: i18n.t('loyaltyCardBenefits.smartWatch'),
        type: 'SMART_WATCH',
      },
      {
        //icon: require('../assets/images/tierBenefits/onboardingKit.png'),
        title: i18n.t('loyaltyCardBenefits.onboardingKit'),
        type: 'ONBOARDING_KIT',
      },
      {
        //icon: require('../assets/images/tierBenefits/extraCoin.png'),
        title: i18n.t('loyaltyCardBenefits.geniusMoreZetCoins'),
        type: 'EXTRA_COINS',
      },
      {
        //icon: require('../assets/images/tierBenefits/coin.png'),

        title: i18n.t('loyaltyCardBenefits.500WelcomePoints'),
        type: 'WELCOME_BONUS',
      },
    ],
    benefits: [
      {
        cardTitle: i18n.t('loyaltyCardBenefits.15%HigherPayout'),
        title: i18n.t('tierBenefits.genius.15percentHigherPayout'),
        subTitle: i18n.t('tierBenefits.15percentHigherPayoutDetail'),
      },
      {
        cardTitle: i18n.t('loyaltyCardBenefits.moreZETCoins'),
        title: i18n.t('tierBenefits.genius.zetCoinsOnSale'),
        subTitle: i18n.t('tierBenefits.2000coins'),
      },
      {
        type: 'SMART_WATCH',
        cardTitle: i18n.t('loyaltyCardBenefits.smartWatch'),
        title: i18n.t('tierBenefits.genius.smartWatch'),
        subTitle: i18n.t('tierBenefits.smartWatchDetail'),
      },
      {
        type: 'ONBOARDING_KIT',
        cardTitle: i18n.t('loyaltyCardBenefits.onboardingKit'),
        title: i18n.t('tierBenefits.genius.onboardingKit'),
        subTitle: i18n.t('tierBenefits.onboardingKitDetail'),
      },
      {
        type: 'ONBOARDING_GIFT',
        cardTitle: i18n.t('loyaltyCardBenefits.onboardingKit'),
        title: i18n.t('tierBenefits.genius.onboardingKit'),
        subTitle: i18n.t('tierBenefits.onboardingKitDetail'),
      },
      {
        type: 'WELCOME_BONUS',
        cardTitle: i18n.t('loyaltyCardBenefits.500WelcomePoints'),
        title: i18n.t('tierBenefits.genius.zetCoinsWelcomeBonus'),
        subTitle: i18n.t('tierBenefits.500coins'),
      },
    ],
    oneTimeBenefits: [
      {
        type: 'SMART_WATCH',
        cardTitle: i18n.t('loyaltyCardBenefits.smartWatch'),
        title: i18n.t('tierBenefits.smartWatch'),
        subTitle: i18n.t('tierBenefits.smartWatchDetail'),
      },
      {
        type: 'ONBOARDING_KIT',
        cardTitle: i18n.t('loyaltyCardBenefits.onboardingKit'),
        title: i18n.t('tierBenefits.onboardingKit'),
        subTitle: i18n.t('tierBenefits.onboardingKitDetail'),
      },
      {
        type: 'WELCOME_BONUS',
        cardTitle: i18n.t('loyaltyCardBenefits.500WelcomePoints'),
        title: i18n.t('tierBenefits.welcomeBonus'),
        subTitle: i18n.t('tierBenefits.500coins'),
      },
    ],
  },
}
export const zetSalesBenefits = [
  {
    icon: <Money />,
    title: i18n.t('geniusProgram.15HigherPayout'),
  },
  {
    icon: <BlueGiftBox />,
    title: i18n.t('geniusProgram.excitingGifts'),
  },
  {
    icon: <ShoppingBag />,
    title: i18n.t('geniusProgram.offers'),
  },
]

export const enum AgentTiers {
  BEGINNER = 'Beginner',
  PRO = 'Pro',
  GENIUS = 'Genius',
  EXPERT = 'Expert',
}

export const enum nextTierExtraPayout {
  BEGINNER = 5,
  PRO = 10,
  EXPERT = 15,
  GENIUS = 15,
}

export const enum TiersWarningDays {
  'Beginner' = 7,
  'Pro' = 7,
  'Genius' = 7,
  'Expert' = 7,
}

export const WarningDays = 7

export const BEGINNER = 'BEGINNER'
export const PRO = 'PRO'
export const GENIUS = 'GENIUS'
export const EXPERT = 'EXPERT'
export const enum TierStatus {
  SKIPPED = 'Skipped',
  ACHIEVED = 'Achieved',
  AVAILABLE = 'Available',
}

export const enum TierStatusType {
  'SKIPPED' = 'SKIPPED',
  'ACHIEVED' = 'ACHIEVED',
  'AVAILABLE' = 'AVAILABLE',
  'CURRENT' = 'CURRENT',
}

export const zetCoinsOnCustomerAddition = [
  {
    type: i18n.t('loyaltyDetails.beginner'),
    points: i18n.t('loyaltyDetails.2zc'),
    borderColor: zetColors.grays[40],
  },
  {
    type: i18n.t('loyaltyDetails.pro'),
    points: i18n.t('loyaltyDetails.3zc'),
    borderColor: zetColors.primary[30],
  },
  {
    type: i18n.t('loyaltyDetails.expert'),
    points: i18n.t('loyaltyDetails.6zc'),
    borderColor: zetColors.warning[10],
  },
  {
    type: i18n.t('loyaltyDetails.genius'),
    points: i18n.t('loyaltyDetails.10zc'),
    borderColor: zetColors.success[30],
  },
]

export const filters = [
  {
    creditCard: {
      name: i18n.t('loyaltyDetails.creditCard'),
      icon: {
        selected: <CreditCardOutlined />,
        notSelected: <CreditCardFilled color={zetColors.neutral.white100} />,
      },
      points: [
        {
          type: i18n.t('loyaltyDetails.beginner'),
          points: i18n.t('loyaltyDetails.500zc'),
          borderColor: zetColors.grays[40],
        },
        {
          type: i18n.t('loyaltyDetails.pro'),
          points: i18n.t('loyaltyDetails.750zc'),
          borderColor: zetColors.primary[30],
        },
        {
          type: i18n.t('loyaltyDetails.expert'),
          points: i18n.t('loyaltyDetails.1000zc'),
          borderColor: zetColors.warning[10],
        },
        {
          type: i18n.t('loyaltyDetails.genius'),
          points: i18n.t('loyaltyDetails.2000zc'),
          borderColor: zetColors.success[30],
        },
      ],
    },
  },
  {
    loan: {
      name: i18n.t('loyaltyDetails.loan'),
      icon: {
        selected: <MoneyBagOutlined />,
        notSelected: <MoneyBagFilled color={zetColors.neutral.white100} />,
      },
      points: [
        {
          type: i18n.t('loyaltyDetails.beginner'),
          points: i18n.t('loyaltyDetails.200zc'),
          borderColor: zetColors.grays[40],
        },
        {
          type: i18n.t('loyaltyDetails.pro'),
          points: i18n.t('loyaltyDetails.300zc'),
          borderColor: zetColors.primary[30],
        },
        {
          type: i18n.t('loyaltyDetails.expert'),
          points: i18n.t('loyaltyDetails.600zc'),
          borderColor: zetColors.warning[10],
        },
        {
          type: i18n.t('loyaltyDetails.genius'),
          points: i18n.t('loyaltyDetails.1000zc'),
          borderColor: zetColors.success[30],
        },
      ],
    },
  },
  {
    otherCategories: {
      name: i18n.t('loyaltyDetails.otherCategories'),
      icon: {
        selected: <MoreOutlined />,
        notSelected: <MoreFilled color={zetColors.neutral.white100} />,
      },
      points: [
        {
          type: i18n.t('loyaltyDetails.beginner'),
          points: i18n.t('loyaltyDetails.10zc'),
          borderColor: zetColors.grays[40],
        },
        {
          type: i18n.t('loyaltyDetails.pro'),
          points: i18n.t('loyaltyDetails.20zc'),
          borderColor: zetColors.primary[30],
        },
        {
          type: i18n.t('loyaltyDetails.expert'),
          points: i18n.t('loyaltyDetails.30zc'),
          borderColor: zetColors.warning[10],
        },
        {
          type: i18n.t('loyaltyDetails.genius'),
          points: i18n.t('loyaltyDetails.40zc'),
          borderColor: zetColors.success[30],
        },
      ],
    },
  },
]
export const enum ZetGifts {
  'ONBOARDING_KIT' = 'Tshirt',
  'AUGMONT_SILVER' = 'Silver',
  'EAR_PHONES' = 'Earphones',
  'SMART_WATCH' = 'Smartwatch',
  'WIRED_EARPHONES' = 'WiredEarphones',
  'WIRELESS_EARPHONES' = 'WirelessEarphones',
  'SMARTWATCH' = 'Smartwatch',
  'ONBOARDING_GIFT' = 'OnboardingGift',
}

export const enum ZetGiftsType {
  'SMART_WATCH' = 'SMART_WATCH',
  'WIRED_EARPHONES' = 'WIRED_EARPHONES',
  'WIRELESS_EARPHONES' = 'WIRELESS_EARPHONES',
  'EAR_PHONES' = 'EAR_PHONES',
  'SMARTWATCH' = 'SMARTWATCH',
  'ONBOARDING_KIT' = 'ONBOARDING_KIT',
  'AUGMONT_SILVER' = 'AUGMONT_SILVER',
  'WELCOME_BONUS' = 'WELCOME_BONUS',
  'ONBOARDING_GIFT' = 'ONBOARDING_GIFT',
}

export const enum ZetGiftSatus {
  'ALLOTTED' = 'ALLOTTED',
  'REDEEMED' = 'REDEEMED',
  'EXPIRED' = 'EXPIRED',
}

export const enum GiftStatus {
  'ADDRESS_EDITABLE' = 'edit_address',
  'PACKING' = 'packing',
  'IN_TRANSIT' = 'in_transit',
  'DELIVERED' = 'delivered',
  'FAILED' = 'failed',
  'AVAILABLE_TO_CLAIM' = 'available_to_claim',
  'DELAYED' = 'delayed',
  'CLAIMED' = 'claimed',
  'COMING_SOON' = 'coming_soon',
  'VIEW_REWARDS' = 'view_rewards',
  'IN_PROGRESS' = 'view_rewards',
  'REDEEMED' = 'view_rewards',
}

export const enum GiftStatusType {
  'ADDRESS_EDITABLE' = 'ADDRESS_EDITABLE',
  'PACKING' = 'PACKING',
  'IN_TRANSIT' = 'IN_TRANSIT',
  'DELIVERED' = 'DELIVERED',
  'FAILED' = 'FAILED',
  'AVAILABLE_TO_CLAIM' = 'AVAILABLE_TO_CLAIM',
  'DELAYED' = 'DELAYED',
  'CLAIMED' = 'CLAIMED',
  'COMING_SOON' = 'COMING_SOON',
  'VIEW_REWARDS' = 'VIEW_REWARDS',
  'IN_PROGRESS' = 'IN_PROGRESS',
  'REDEEMED' = 'REDEEMED',
}

export const UnClaimedGiftStatusArray = [
  'ADDRESS_EDITABLE',
  'AVAILABLE_TO_CLAIM',
  'IN_PROGRESS',
  'REDEEMED',
]
export const UnClaimedGiftCTAArray = [
  'IN_PROGRESS',
  'AVAILABLE_TO_CLAIM',
  'REDEEMED',
]

export const loyaltySaleProgressStatus = ['ACHIEVED', 'SKIPPED']
export const GiftStatusText = {
  edit_address: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.editAddress')}
    </BTN>
  ),
  packing: (
    <Stack className="bg-grays-30 rounded-xl px-2">
      <BTN className="text-grays-70">{i18n.t('loyaltyDetails.packing')}</BTN>
    </Stack>
  ),
  in_transit: (
    <Stack className="bg-grays-30 rounded-xl px-2">
      <BTN className="text-warning-100">
        {i18n.t('loyaltyDetails.inTransit')}
      </BTN>
    </Stack>
  ),
  delivered: (
    <Stack className="bg-success-10 rounded-xl px-2">
      <BTN className="text-success-100">
        {i18n.t('loyaltyDetails.delivered')}
      </BTN>
    </Stack>
  ),
  available_to_claim: (
    <BTN className="text-primary-100">{i18n.t('loyaltyDetails.claim')}</BTN>
  ),
  claimed: (
    <Stack className="bg-success-10 rounded-xl px-2">
      <BTN className="text-success-100">{i18n.t('loyaltyDetails.claimed')}</BTN>
    </Stack>
  ),
  coming_soon: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.comingSoon')}
    </BTN>
  ),
  view_rewards: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.viewRewards')}
    </BTN>
  ),
  failed: (
    <BTN className="text-primary-100">
      {i18n.t('loyaltyDetails.unsuccessful')}
    </BTN>
  ),
  available_to_claim_aug: (
    <Stack className="bg-grays-30 rounded-xl px-2">
      <BTN className="text-grays-70">{i18n.t('loyaltyDetails.processing')}</BTN>
    </Stack>
  ),
  view_rewards_aug: (
    <Stack className="bg-success-10 rounded-xl px-2">
      <BTN className="text-success-100">
        {i18n.t('loyaltyDetails.processed')}
      </BTN>
    </Stack>
  ),
}

export const giftObject = {
  Earphones: {
    heading: i18n.t('loyaltyDetails.earphones'),
    subHeading: i18n.t('loyaltyDetails.earphonesSubHeading'),
    icon: <Earphones />,
  },
  Tshirt: {
    heading: i18n.t('loyaltyDetails.zetOnboardingKit'),
    subHeading: i18n.t('loyaltyDetails.zetOnboardingKitSubHeading'),
    icon: <DeliveryBox />,
  },
  Silver: {
    heading: i18n.t('loyaltyDetails.silver'),
    subHeading: i18n.t('loyaltyDetails.earnSilver'),
    icon: <DigitalSilver />,
  },
  Smartwatch: {
    heading: i18n.t('loyaltyDetails.smartWatch'),
    subHeading: i18n.t('loyaltyDetails.smartWatchSubHeading'),
    icon: <SmartWatch />,
  },
  WiredEarphones: {
    heading: i18n.t('loyaltyDetails.earphones'),
    subHeading: i18n.t('loyaltyDetails.smartWatchSubHeading'),
    icon: <WiredEarPhones />,
  },
  WirelessEarphones: {
    heading: i18n.t('loyaltyDetails.premiumEarphones'),
    subHeading: i18n.t('loyaltyDetails.wirelessEarphonesSubHeading'),
    icon: <Earphones />,
  },
  OnboardingGift: {
    heading: i18n.t('loyaltyDetails.zetOnboardingKit'),
    subHeading: i18n.t('loyaltyDetails.zetOnboardingKitSubHeading'),
    icon: <OnboardingGift />,
  },
}

export const initialState = [
  {
    title: i18n.t('loyaltyDetails.beginner'),
    isActive: false,
    isDone: false,
  },
  { title: i18n.t('loyaltyDetails.pro'), isActive: false, isDone: false },
  { title: i18n.t('loyaltyDetails.expert'), isActive: false, isDone: false },
  { title: i18n.t('loyaltyDetails.genius'), isActive: false, isDone: false },
]

export const levelIndexes = {
  Beginner: 0,
  Pro: 1,
  Expert: 2,
  Genius: 3,
}

export const TierTotalSales = {
  Beginner: 0,
  Pro: 2,
  Expert: 7,
  Genius: 15,
}

export const loyaltyFaqVideos = {
  becomeGenuis: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/becomeGenuis.jpg',
    videoId: 'cry3VRqDsWw',
  },
  higherPayout: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/higherPayout.jpg',
    videoId: 'cry3VRqDsWw',
  },
  zetCoins: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/zetCoins.jpg',
    videoId: 'cry3VRqDsWw',
  },
  rewardsAndCoins: {
    banner:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/loyalty/videoBanners/rewardsAndCoins.jpg',
    videoId: 'cry3VRqDsWw',
  },
  beginner: {
    banner: '',
    videoId: 'xYuuseIooa8',
  },
  pro: {
    banner: '',
    videoId: '3xtKLtqqiQY',
  },
  expert: {
    banner: '',
    videoId: '8ZrkhYH2J4Q',
  },
  genius: {
    banner: '',
    videoId: '0BkMmCFiVw8',
  },
}
